import React, {Component, Fragment} from 'react';
import {DetailContainer} from '../DetailContainer';
import {Button, Form, Label, Input} from 'reactstrap';
import {formatDate} from '../../invoices/containers/InvoiceDetail';
import {connect} from 'react-redux';
import Loading from '../../apa/components/Loading';
import autobind from 'autobind-decorator';
import { BaseUrl } from '../../BaseUrl/BaseUrl';

@connect(
    state => (
        {
            auth: state.apa
        }
    )
)
export default class ReportPrint extends Component {

    constructor(props) {
        super(props);
        this.state = {
            date: formatDate(new Date()),
            contact: '',
            note: '',
            contactList: [],
            isLoading: true,
            printed: false,
            print: null,
            participants: [],
            contacts: []
        };
    }

    componentDidMount() {
        const id = this.props.match.params.id;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Token ${this.props.auth.token}`
        };
        fetch(
            `${BaseUrl}/api/customers/${id}/`,
            {headers}
        ).then(res => res.json())
            .then(
                customer => {
                    this.setState({
                        isLoading: false,
                        customer: customer
                    })
                }
            )

    }

    @autobind
    submit() {
        const {
            id,
            report_id
        } = this.props.match.params;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Token ${this.props.auth.token}`
        };
        const data = {
            catalog: report_id,
            customer: id,
            note: this.state.note,
            contact_ids: this.state.contacts,
            date: this.state.date,
            participants_ids: this.state.participants,
        };
        const body = JSON.stringify(data)
        this.setState({isLoading: true});
        fetch(
            `${BaseUrl}/api/report_prints/`,
            {headers, method: 'POST', body}
        ).then(
            res => res.json()
        ).then(
            res => {
                this.setState({
                    printed: true,
                    print: res,
                    isLoading: false
                })
            }
        )
    }

    render() {
        const {
            id,
        } = this.props.match.params;
        if (this.state.isLoading)
            return <Loading/>;
        return (
            <DetailContainer id={id}>
                <h1>{this.state.customer.name}</h1>
                {!this.state.printed &&
                <Form>
                    <Label>
                        Datum
                    </Label>
                    <Input type='date' value={this.state.date} onChange={e => this.setState({date: e.target.value})}/>
                    <Label>
                        Verantwortliche
                    </Label>
                    <Input type='select' multiple value={this.state.contacts} required
                           onChange={() => this.setState({contacts: Array.from(event.target.selectedOptions, (item) => item.value)})}>
                        {
                            this.state.customer.contacts.map(
                                contact => <option key={`contact_option_${contact.id}`}
                                                   value={contact.id}>{contact.name}</option>
                            )
                        }
                    </Input>
                    <Label>
                        Beteiligte Personen
                    </Label>
                    <Input type='select' multiple value={this.state.participants} required
                           onChange={() => this.setState({participants: Array.from(event.target.selectedOptions, (item) => item.value)})}>
                        {
                            this.state.customer.contacts.map(
                                contact => <option key={`participation_option_${contact.id}`}
                                                   value={contact.id}>{contact.name}</option>
                            )
                        }
                    </Input>
                    <Label>
                        Anmerkungen
                    </Label>
                    <Input type='textarea' value={this.state.note}
                           onChange={e => this.setState({note: e.target.value})}/>
                    <br/>
                    <Button color='primary' onClick={this.submit}>
                        Speichern
                    </Button>
                </Form>
                }
                { this.state.printed &&
                <Fragment>
                    <a href={this.state.print.file}>Download</a>
                    <ul>
                        { this.state.print.attachments && 
                            this.state.print.attachments.map(
                                (att, index) => <li key={`att_${index}`}><a href={att.file}>{att.file}</a></li>
                            )
                        }
                    </ul>
                </Fragment>
                }
            </DetailContainer>
        );
    }

} /* 
<iframe 
                    src={'https://view.officeapps.live.com/op/embed.aspx?src=' + this.state.print.file}
                    frameBorder="0"
                    width="100%"
                    height="800px"
                >O365 Preview</iframe>
            */